import {ssrSafeLocation} from '@github-ui/ssr-utils'
import {XIcon} from '@primer/octicons-react'
import {IconButton, Label, Link, Tooltip} from '@primer/react'
import {useCallback} from 'react'

export function buildUiPreviewExitUrl(href: string, origin: string) {
  const url = new URL(href, origin)
  url.searchParams.delete('_ui_sha')
  url.searchParams.set('_clear_ui_sha', 'true')

  return url.toString()
}

export function UIPreviewLabel({uiPreview}: {uiPreview?: string}) {
  const handleClick = useCallback(() => {
    window.location.href = buildUiPreviewExitUrl(ssrSafeLocation.href, ssrSafeLocation.origin)
  }, [])

  if (!uiPreview) return null

  return (
    <Label variant="done" className="mr-1" data-testid="ui-preview">
      <Link
        href={`https://github.com/github/github-ui/commit/${uiPreview}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="UI PREVIEW: View commit in github-ui"
        className="color-fg-done no-underline"
      >
        UI PREVIEW
      </Link>
      <Tooltip text="Leave UI preview mode">
        <IconButton
          variant="invisible"
          icon={XIcon}
          size="small"
          aria-label="Leave UI preview mode"
          className="color-fg-done"
          onClick={handleClick}
        />
      </Tooltip>
    </Label>
  )
}
